/**
 * Delegate event to selector.
 * @param selector
 * @param fn
 * @returns {(function(*): void)|*}
 */
const delegate = (selector, fn) => {
    return (e) => {
        let closest = e.target.closest(selector);

        if (closest) {
            e.closestMatch = closest;

            fn(e);
        }
    };
};

/**
 * Debounce event.
 * @param fn
 * @param delay
 * @returns {(function(): void)|*}
 */
const debounce = (fn, delay = 300) => {
    let timeout;

    return () => {
        clearTimeout(timeout);

        timeout = setTimeout(fn, delay);
    };
};

/**
 * Map options object deep.
 *
 * @param originalOptions {Object} Original options object
 * @param newOptions {Object} New options object that will overwrite correlating values
 * @returns {Object}
 */
const mapOptions = (originalOptions, newOptions) => {
    if (!originalOptions) {
        return newOptions;
    }

    let settings;

    if (Array.isArray(originalOptions)) {
        settings = originalOptions.map((x) => x);
    } else {
        settings = Object.assign({}, originalOptions);
    }

    Object.keys(newOptions).forEach((strKey) => {
        if (typeof newOptions[strKey] === 'object'
            && !(newOptions[strKey] instanceof Node)
            && !(newOptions[strKey] instanceof Function)
        ) {
            settings[strKey] = mapOptions(settings[strKey], newOptions[strKey]);
        } else {
            settings[strKey] = newOptions[strKey];
        }
    });

    return settings;
};

/**
 * Lock scroll on element.
 */
function lockScroll(el = document.documentElement) {
    document.documentElement.style.setProperty(
        '--scrollbar-width',
        (window.innerWidth - document.documentElement.scrollWidth) + 'px'
    );

    el.classList.add('lock-scroll');
}

/**
 * Unlock scroll on element.
 * @param el
 */
function unlockScroll(el = document.documentElement) {
    el.classList.remove('lock-scroll');
}

export {
    delegate,
    debounce,
    mapOptions,
    lockScroll,
    unlockScroll,
};
